import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/ZohoIntegration/ZohoSetup';

const ZohoSetup = () => ((orgContainer(InnerComponent)));
export default ZohoSetup;
